import { ETabType } from '../../types/filters';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EАctiveTabActionTypes {
  SET_ACTIVE_TAB = 'SET_ACTIVE_TAB',
  INITIALIZE_FROM_URL = 'INITIALIZE_FROM_URL',
}

export interface ISetActiveTabActionPayload {
  activeTab: ETabType;
  isInitialized: boolean;
}

export interface IInitializeFromUrlActionPayload {
  activeTab: ETabType | null;
}

export type TSetActiveTabAction = ITypedReduxAction<EАctiveTabActionTypes.SET_ACTIVE_TAB, ISetActiveTabActionPayload>;
export type TInitializeFromUrlAction = ITypedReduxAction<
  EАctiveTabActionTypes.INITIALIZE_FROM_URL,
  IInitializeFromUrlActionPayload
>;

export type TActiveTabActions = TSetActiveTabAction | TInitializeFromUrlAction;
